
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","width":"36","height":"36","rx":"5","fill":"#CEA40A"}}),_c('path',{attrs:{"d":"M18.5 20.077V27M15.039 27h6.923M13.654 15.923A4.154 4.154 0 019.5 11.77v-1.384h4.846v5.538h-.692zM23.346 15.923A4.154 4.154 0 0027.5 11.77v-1.384h-4.846v5.538h.692z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.654 15.923a4.154 4.154 0 01-8.308 0V9h8.308v6.923z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    